import ScopeAppComponent from './content'

export default ScopeAppComponent



// WEBPACK FOOTER //
// app/javascript/components/frags/ScopeList/index.js